import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './context/UserContext';
import { App as AntApp } from 'antd';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <UserProvider>
    {/* Proveedor de contexto de Ant Design para modales v5 */}
    <AntApp>
      <App />
    </AntApp>
  </UserProvider>
);

reportWebVitals();
